import React from 'react'
import { useTranslation } from 'next-i18next'
import { formatCurrency } from '../../../lib/utils/formatNumber'
import { HeroIcons } from '../../../lib/utils/heroIcons'
import useCurrency from '../../../hooks/useCurrency'
import useLocale from '../../../hooks/useLocale'

interface MonthlyYieldsCardProps {
  currentMonthlyYields: number
}

export default function MonthlyYieldsCard({
  currentMonthlyYields,
}: MonthlyYieldsCardProps) {
  const { t } = useTranslation('dashboard')

  const { currency } = useCurrency()
  const { locale } = useLocale()

  const displayedData = (
    <div className="relative flex">
      <div className="mt-auto flex items-baseline text-4xl font-bold">
        <span className="font-normal">~</span>
        {formatCurrency(currentMonthlyYields, 2, 2, currency, locale)}
        <div className="ml-1 text-sm font-normal">
          /{t('statsCards.monthlyYieldsCard.month')}
        </div>
      </div>
    </div>
  )

  return (
    <div>
      <div className="relative overflow-hidden rounded-md bg-white">
        <div className="mb-3 flex items-center space-x-4 px-3 pt-3">
          <div className="w-1/6">
            <div className="rounded-md bg-primary p-3">
              <HeroIcons.BanknotesIcon
                className="text-white"
                aria-hidden="true"
              />
            </div>
          </div>
          <div className="w-5/6">
            <div className="flex">
              <div className="flex-grow">
                <div className="text-sm font-medium text-neutralBlack/80">
                  {t('statsCards.monthlyYieldsCard.title')}
                </div>
                <div className="text-2xl font-semibold text-neutralBlack">
                  {displayedData}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
